/* global require, SocialLikesNext */
;$(function () {
  'use strict'

  SocialLikesNext.autoInit()
})
